<app-collaborators-invitation-success [event]="event$ | async" />
